import React, { useState, useEffect, useRef } from 'react';

import Navigation from '../Navigation/Navigation';
// import FilmScoreData from '../Data/FilmScoreData';
import BrandsData from '../Data/BrandsData';
// import Brands from '../Landing/Brands';
// import BrandsBanner from '../Tools/BrandsBanner';
// import MusicPlayer from '../Tools/MusicPlayer';
// import ProjectModal from '../Tools/ProjectModal';
// import ListItem from '../List/ListItem';
import PlacementItem from './PlacementItem';
import Collaborators from '../Tools/Collaborators';
import BottomPlayBar from '../Tools/BottomPlayBar';

import PlacementData from '../Data/PlacementData';

// import pause_circle from '../../Images/pause-circle.svg';
// import play_circle from '../../Images/play-circle.svg';
// import play_black from '../../Images/play_black.svg';
// import pause_black from '../../Images/pause_black.svg';
// import Cross from '../../Images/x.svg';
import profpic from '../../Images/Andy.jpeg';
// import BANNER from '../../Images/banner1.jpg';

// const BANNER = 'https://images.pexels.com/photos/2426085/pexels-photo-2426085.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';
// const profpic = 'https://images.pexels.com/photos/1040880/pexels-photo-1040880.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';

const Placements = ({dimensions,width,navigate}) => {
	const [ hover, setHover ] = useState('');
	const [ playing, setPlaying ] = useState('');
	const [ playBack, setPlayBack ] = useState(0);

	const audioRef = useRef();

	useEffect(()=>{window.scrollTo(0, 0);},[]);

	function playPressed(e,i) {
		console.log(playing);
		const audio = document.getElementById(e);
		if(playing.id === e){
			if(playing.play === true){
				audio.pause();
				setPlaying({id:e,i:i,play:false});
			} else {
				audio.play();
				setPlaying({id:e,i:i,play:true});
			}
		} else {
			// stop previously playing song if playing
			if(playing.play === true){
				const audio_old = document.getElementById(playing.id);
				audio_old.pause();
			}
			audio.play();
			setPlaying({id:e,i:i,play:true});
		}
	}

	function brandPlacements() {
		const brands = ['netflix','hulu','hbo_max','peacock','honda','pure_fishing','bleeding_fingers'];
		let arr = [];
		let high = 40;
		if(dimensions.width < 800) high = 30;
		if(dimensions.width < 600) high = 20;
		for(let i = 0; i < brands.length; i++){
			arr.push(
				<div key={i} style={{marginLeft:high/2,marginRight:high/2}}>
					<img src={BrandsData[brands[i]].img_light} alt='brand' style={{height:high}} />
				</div>
			)
		}
		return <div className='flexCenter' style={{marginTop:20,width:width,overflow:'hidden'}}>{arr}</div>
	}

	function projectLoop() {
		let arr = [];
		for(let i = 0; i < PlacementData.length; i++){
			arr.push(
				<div key={i}>
					<PlacementItem item={PlacementData[i]} i={i} hover={hover} setHover={setHover} width={width}
							playPressed={playPressed} playing={playing} setPlaying={setPlaying}
							dimensions={dimensions} playBack={playBack} setPlayBack={setPlayBack} audioRef={audioRef} />
				</div>
			)
		}
		return <div className='flexHeightCenter flexWrap' onMouseLeave={()=>{setHover('')}}>{arr}</div>;
	}

	let className = 'flexHeightCenter';
	let textWide = width-150;
	if(dimensions.width < 700){
		className = '';
		textWide = width;
	}

	return(
		<div>
			<Navigation navigate={navigate} width={width} />
			{dimensions.width < 700
				? null
				: <div style={{height:60}}></div>
			}

			{/*<div style={{width:'100%',height:240,overflow:'hidden'}} className='flexCenter'>
				<img src={BANNER} alt='BANNER' style={{width:'100%'}} />
			</div>
			<BrandsBanner dimensions={dimensions} />*/}
			<div style={{height:20}}></div>

			{/*<div className='fadeIn' style={{textAlign:'center'}}>
				<div className='heroText bold' style={{marginBottom:10}}>Songwriting</div>
				<div className='heading bold'>Film, TV & Artists</div>
			</div>*/}

			{dimensions.width < 700
				? <div className='riseUpC'>
					<div style={{width:width,margin:'auto',zIndex:200,pointerEvents:'none'}} className=' relative'>
						<div style={{height:20}}></div>
						<div className={className}>
							<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30,pointerEvents:'auto'}}
									className='flexCenter' onClick={()=>{navigate('/')}}>
								<img src={profpic} alt='profpic' style={{width:'100%'}} />
							</div>
							<div style={{width:textWide}}>
								
							</div>
						</div>
						{/*<div style={{height:mini_high}}></div>*/}
					</div>
					<div style={{width:width,margin:'auto',marginTop:-120}} className=''>
						{/*<div style={{height:20}}></div>*/}
						<div className={className}>
							<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30}} className='flexCenter'
									onClick={()=>{navigate('/')}}>
								{/*<img src={profpic} alt='profpic' style={{width:'100%'}} />*/}
							</div>
							<div style={{width:textWide}}>
								<div className='heroText bold' style={{marginBottom:10}} onClick={()=>{navigate('/')}}>Film scoring</div>
								<div className='heading bold'>Composer of music for film and TV</div>
							</div>
						</div>
						{/*<div style={{height:mini_high}}></div>*/}
					</div>
				</div>
				: <div style={{width:width,margin:'auto'}} className='riseUp'>
					<div style={{height:20}}></div>
					<div className={className}>
						<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30}} className='flexCenter'
								onClick={()=>{navigate('/')}}>
							<img src={profpic} alt='profpic' style={{width:'100%'}} />
						</div>
						<div style={{width:textWide}}>
							<div className='heroText bold' style={{marginBottom:10}} onClick={()=>{navigate('/')}}>Songwriting</div>
							<div className='heading bold'>Film, TV & Artists</div>
						</div>
					</div>
					{/*<div style={{height:mini_high}}></div>*/}
				</div>
			}
			
			<div style={{width:width,margin:'auto'}} className='riseUp'>
				{/*<div style={{height:20}}></div>
				<div className={className}>
					<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30}} className='flexCenter'
							onClick={()=>{navigate('/')}}>
						<img src={profpic} alt='profpic' style={{width:'100%'}} />
					</div>
					<div style={{width:textWide}}>
						<div className='heroText bold' style={{marginBottom:10}} onClick={()=>{navigate('/')}}>Songwriting</div>
						<div className='heading bold'>Film, TV & Artists</div>
					</div>
				</div>*/}
				<div style={{height:20}}></div>
				{brandPlacements()}
				<div style={{height:60}}></div>
				{projectLoop()}
				{/*{projectLoop2()}*/}
				<div style={{height:80}}></div>
				<div style={{height:30}}></div>

				<Collaborators width={width} dimensions={dimensions} />
				<div style={{height:100}}></div>
				
			</div>
			<BottomPlayBar width={width} playing={playing} playPressed={playPressed} route={'/placements'}
					audioRef={audioRef} playBack={playBack} dimensions={dimensions} />
		</div>
	)
}

export default Placements;